import { errorAction } from './notifications';
import { throwErrorIfNotHandled } from './errorMiddleware';

export function handleManualPoError(err, dispatch) {
    if (err.status === 422) {
        err.json().then(({ errors }) => {
            if (errors) {
                dispatch(errorAction(`Failed to send manual po - ${errors}`));
            } else {
                dispatch(errorAction(`Failed to send manual po`));
            }
        });
    } else {
        throwErrorIfNotHandled(`Failed to send manual po`)(err);
    }
}
